import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { CSSProperties } from "react";

interface IAmountCard {
  title: string;
  amount: string;
  amountColor?: string;
  isError?: boolean;
  style?: CSSProperties;
  isSmall?: boolean;
  specialStyle?: "positive" | "negative";
}

const AmountCard = ({
  title,
  amount,
  amountColor = "g900",
  isError,
  style,
  isSmall,
  specialStyle,
}: IAmountCard) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(
        styles.container,
        isError && styles.error_container,
        isSmall && styles.containerSmall,
        specialStyle && styles[specialStyle]
      )}
      style={{ ...style }}
    >
      <p
        className={classNames(
          styles["g400"],
          styles["subtitle2"],
          styles.title,
          isSmall && styles.titleSmall
        )}
      >
        {title}
      </p>
      <h1
        className={classNames(
          styles[amountColor],
          styles["h1"],
          styles.title,
          isSmall && styles.descriptionSmall
        )}
      >
        {amount + " " + t("lbl_saudi_currency")}
      </h1>
    </div>
  );
};

export default AmountCard;
